import { createContext, useContext, useEffect } from 'react';
import { themes } from '../theme';

// helper to get the subdomain
const getSubdomain = () => {
  const host = window.location.hostname;
  const parts = host.split('.');
  return parts.length > 2 ? parts[2].toLowerCase() : 'default';
};

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const subdomain = getSubdomain();
    const theme =
    subdomain === 'bewellsupport'
      ? themes.bws
      : themes.default;
  
    // Immediately apply theme variables
    Object.entries(theme).forEach(([key, value]) => {
      document.documentElement.style.setProperty(key, value);
    });
  
    return (
      <ThemeContext.Provider value={theme}>
        {children}
      </ThemeContext.Provider>
    );
  };

export const useTheme = () => useContext(ThemeContext);